export enum EthnicityType {
  CAUCASIAN = 'CAUCASIAN',
  AFRICAN_AMERICAN = 'AFRICAN_AMERICAN',
  NORTH_EAST_ASIAN = 'NORTH_EAST_ASIAN',
  SOUTH_EAST_ASIAN = 'SOUTH_EAST_ASIAN',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}
